
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../BaseUrl";
import { toastError, toastSuccess } from "../../AlertMessage/AlertMessage";

// Get Table Data
export const PlantationDetailsPartFirstTableDataAPI = createAsyncThunk("PlantationDetailsPartFirstTableData", async ({ data }) => {
    const {
        FinancialYearID,
        MonthsID,
        T_BeneficiaryWisePlantation_FinancialYearDetailsID,
        M_BeneficiaryDetailsID,
        M_TableUserMasterID,
        handleGetFormData,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
  
    return fetch(`${BaseUrl}/Transaction/Get_Web_PlantationDetails_1_Select?FinancialYearID=${FinancialYearID}&MonthsID=${MonthsID}&T_BeneficiaryWisePlantation_FinancialYearDetailsID=${T_BeneficiaryWisePlantation_FinancialYearDetailsID}&M_BeneficiaryDetailsID=${M_BeneficiaryDetailsID}&M_TableUserMasterID=${M_TableUserMasterID}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data) {
                    handleGetFormData(result.data.table)
                    return result.data
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                handleGetFormData(result.data)
                return result
            }
        })
})

const PlantationDetailsPartFirstTableDataSlice = createSlice({
    name: "PlantationDetailsPartFirstTableData",
    initialState: {
        isFirstPartLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlantationDetailsPartFirstTableDataAPI.pending, (state, action) => {
            state.isFirstPartLoading = true;
        });
        builder.addCase(PlantationDetailsPartFirstTableDataAPI.fulfilled, (state, action) => {
            state.isFirstPartLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(PlantationDetailsPartFirstTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isFirstPartLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const PlantationDetailsPartFirstTableDataReducer = PlantationDetailsPartFirstTableDataSlice.reducer

// InsertUpdate Table Data
export const PlantationDetailsPartFirstPostAPI = createAsyncThunk("PlantationDetailsPartFirstPost", async ({ data }) => {
    const {

        T_BeneficiaryWisePlantation_MonthDetailsID,
        M_BeneficiaryDetailsID,
        T_BeneficiaryWisePlantation_FinancialYearDetailsID,
        T_BeneficiaryWisePlotsDetailsID,
        MonthsID,
        No_of_PlantsReceived,
        No_of_PlantsPlanted,
        M_TableUserMasterID,
        No_of_PlantsSurvived,
        No_of_Plants_kept_at_home,
        No_of_Plants_Died_at_home,
        Area,
        M_UnitID,
        token,
        handleIsDataPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_BeneficiaryWisePlantation_MonthDetailsID", T_BeneficiaryWisePlantation_MonthDetailsID);
    formdata.append("M_BeneficiaryDetailsID", M_BeneficiaryDetailsID);
    formdata.append("T_BeneficiaryWisePlantation_FinancialYearDetailsID", T_BeneficiaryWisePlantation_FinancialYearDetailsID);
    formdata.append("T_BeneficiaryWisePlotsDetailsID", T_BeneficiaryWisePlotsDetailsID);
    formdata.append("MonthsID", MonthsID);
    formdata.append("No_of_PlantsReceived", No_of_PlantsReceived);
    formdata.append("No_of_PlantsPlanted", No_of_PlantsPlanted);
    formdata.append("No_of_PlantsSurvived", No_of_PlantsSurvived);
    formdata.append("No_of_Plants_kept_at_home", No_of_Plants_kept_at_home);
    formdata.append("No_of_Plants_Died_at_home", No_of_Plants_Died_at_home);
    formdata.append("Area", Area);
    formdata.append("M_UnitID", M_UnitID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);
    
    const requestOptions = {
      method: "PATCH",
      headers: myHeaders,
      body: formdata,
      redirect: "follow"
    };
    
    fetch(`${BaseUrl}/Transaction/APK_T_BeneficiaryWisePlantation_MonthDetails_Update`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                handleIsDataPost()
                toastSuccess(result.message)
            } else {
                toastError("Something went wrong")
            }
            return result
        })
})

const PlantationDetailsPartFirstPostSlice = createSlice({
    name: "BeneficiaryPost",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlantationDetailsPartFirstPostAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(PlantationDetailsPartFirstPostAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.PostData = action.payload;
        });
        builder.addCase(PlantationDetailsPartFirstPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;
            // toastError('Something went wrong')

        });
    },
})

export const PlantationDetailsPartFirstPostReducer = PlantationDetailsPartFirstPostSlice.reducer

export const PlantationDetailsPartFirstDeleteAPI = createAsyncThunk("PlantationDetailsPartFirstDelete", async ({ data }) => {
    const {
        T_BeneficiaryWisePlotsDetailsID,
        M_TableUserMasterID,
        token,
        handleIsPost,
        handleShowDelete
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_BeneficiaryWisePlotsDetailsID",T_BeneficiaryWisePlotsDetailsID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "DELETE",
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Transaction/APK_T_BeneficiaryWisePlotsDetails_Delete`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleIsPost()
                handleShowDelete()
            } else {
                toastError(result.message)
            }
            return result
        })
})

const PlantationDetailsPartFirstDeleteSlice = createSlice({
    name: "PlantationDetailsPartFirstDelete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlantationDetailsPartFirstDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(PlantationDetailsPartFirstDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(PlantationDetailsPartFirstDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;

        });
    },
})

export const PlantationDetailsPartFirstDeleteReducer = PlantationDetailsPartFirstDeleteSlice.reducer

// Get Table Data
export const PlantationTypeTableDataAPI = createAsyncThunk("PlantationTypeTableData", async ({ Data }) => {
    const {
        T_BeneficiaryWisePlantation_FinancialYearDetailsID,
        M_BeneficiaryDetailsID,
        Top,
        M_TableUserMasterID,
        handleGetFormData,
        token
    } = Data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
  
    return fetch(`${BaseUrl}//Transaction/Get_APK_PlantationDetails_1_PlantingType_Select?T_BeneficiaryWisePlantation_FinancialYearDetailsID=${T_BeneficiaryWisePlantation_FinancialYearDetailsID}&M_BeneficiaryDetailsID=${M_BeneficiaryDetailsID}&M_TableUserMasterID=${M_TableUserMasterID}&Top=${Top}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data) {
                    
                    return result.data
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                handleGetFormData(result.data)
                return result
            }
        })
})

const PlantationTypeTableDataSlice = createSlice({
    name: "PlantationTypeTableData",
    initialState: {
        isFirstPartLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlantationTypeTableDataAPI.pending, (state, action) => {
            state.isFirstPartLoading = true;
        });
        builder.addCase(PlantationTypeTableDataAPI.fulfilled, (state, action) => {
            state.isFirstPartLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(PlantationTypeTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isFirstPartLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const PlantationTypeTableDataReducer = PlantationTypeTableDataSlice.reducer